import React from 'react';
import { EmailProvider } from 'nekst-api';
import BaseProviderCard, { ProviderCardProps, ProviderConfig } from './BaseProviderCard';
import outlookIcon from './outlook.png';

const OUTLOOK_CONFIG: ProviderConfig = {
  name: 'Outlook',
  icon: outlookIcon,
  provider: EmailProvider.OUTLOOK,
  lockedByProvider: 'Gmail',
};

export default function OutlookProviderCard(props: ProviderCardProps) {
  return <BaseProviderCard config={OUTLOOK_CONFIG} {...props} />;
}
